export const siteInfo = {
  name: "Frostyware 3D",
  tagline: "Premium 3D Printing Solutions",
  location: "Motor Market, Manimajra, Chandigarh",
  whatsappNumber: "919056382775",
  whatsappLink:
    "https://wa.me/919056382775?text=Hi%20Frostyware%203D!%20I'm%20interested%20in%20your%203D%20printing%20services.",
};

export const navLinks = [
  { id: "services", label: "Services" },
  { id: "products", label: "Products" },
  { id: "ordering", label: "How to Order" },
  { id: "contact", label: "Contact" },
];

export const services = [
  {
    id: 1,
    title: "3D Printing Services",
    description:
      "High-quality, durable prints using premium materials. From PLA to resin, we deliver precision in every layer.",
    icon: "Printer",
  },
  {
    id: 2,
    title: "3D Modeling Services",
    description:
      "From concept to printable file. Our expert designers transform your ideas into detailed, print-ready 3D models.",
    icon: "PenTool",
  },
  {
    id: 3,
    title: "100% Customization",
    description:
      "Every project is tailored completely to your demands. No templates, no limits \u2014 just your vision, realized in 3D.",
    icon: "Sliders",
  },
];

export const products = [
  {
    id: 1,
    name: "Custom Lithophanes",
    subtitle: "Memory Lamps",
    price: "\u20B9550",
    priceNote: "Starting from",
    description:
      "Beautiful translucent prints that glow with your cherished memories. Perfect as personalized gifts.",
    image:
      "https://customer-assets.emergentagent.com/job_ice-prints/artifacts/bh2d2v9o_Gemini_Generated_Image_ifsxy4ifsxy4ifsx.png",
    tag: "Popular",
  },
  {
    id: 2,
    name: "Personalized 3D Keyrings",
    subtitle: "Custom Keychains",
    price: "\u20B915",
    priceNote: "Starting from",
    description:
      "Unique keyrings in any shape, name, or text. Lightweight, durable, and eye-catching accessories.",
    image:
      "https://customer-assets.emergentagent.com/job_ice-prints/artifacts/kx2u5fg6_Gemini_Generated_Image_k35owok35owok35o.png",
    tag: "Best Value",
  },
  {
    id: 3,
    name: "3D Printed QR Codes",
    subtitle: "& UPI Scanners",
    price: "\u20B9550",
    priceNote: "Starting from",
    description:
      "Durable, always-scannable QR codes and UPI scanners. Perfect for shops and businesses.",
    image:
      "https://customer-assets.emergentagent.com/job_ice-prints/artifacts/30pcdgou_Gemini_Generated_Image_b78kmfb78kmfb78k.png",
    tag: "For Business",
  },
  {
    id: 4,
    name: "3D Look-alike Sculptures",
    subtitle: "Bust or Full Body",
    price: "\u20B91,500",
    priceNote: "Starting from",
    description:
      "Stunning 3D printed replicas of yourself or loved ones. Available as bust or full body sculptures.",
    image:
      "https://customer-assets.emergentagent.com/job_ice-prints/artifacts/1c24qo7q_Gemini_Generated_Image_c6pro6c6pro6c6pr.png",
    tag: "Premium",
  },
  {
    id: 5,
    name: "Custom 3D Products",
    subtitle: "Toys, Prototypes & More",
    price: "Contact for Quote",
    priceNote: "",
    description:
      "From toys to prototypes to replacement parts \u2014 if you can imagine it, we can print it.",
    image:
      "https://images.pexels.com/photos/35063297/pexels-photo-35063297.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "Custom",
  },
];

export const testimonials = [
  {
    id: 1,
    name: "Harpreet Singh",
    location: "Chandigarh",
    rating: 5,
    product: "Number Plate Keyrings",
    review:
      "Got bulk keyrings made for our entire fleet of vehicles. The quality is outstanding and the turnaround was super fast. Highly recommend Frostyware 3D for any custom keyring work!",
    image:
      "https://customer-assets.emergentagent.com/job_ice-prints/artifacts/pxhd8q8j_IMG_4388.jpeg",
  },
  {
    id: 2,
    name: "Manpreet Kaur",
    location: "Panchkula",
    rating: 5,
    product: "Wedding Lithophane",
    review:
      "Ordered a lithophane as a wedding gift and it turned out absolutely beautiful. The warm glow brings the photo to life. Everyone at the wedding was amazed. Thank you Frostyware!",
    image:
      "https://customer-assets.emergentagent.com/job_ice-prints/artifacts/mtrlgv3e_ee7cc5a1-6547-4927-aed1-a6711fbaf494.JPG",
  },
  {
    id: 3,
    name: "Rajesh Sharma",
    location: "Manimajra",
    rating: 5,
    product: "Business Keyrings",
    review:
      "Got custom keyrings with our shop details printed on them. Great for brand promotion and customers love them. Affordable prices and excellent print quality. Will order more soon!",
    image:
      "https://customer-assets.emergentagent.com/job_ice-prints/artifacts/yxuvfy1f_IMG_4367.jpeg",
  },
  {
    id: 4,
    name: "Gurpreet Sandhu",
    location: "Mohali",
    rating: 5,
    product: "3D Bust Sculpture",
    review:
      "The 3D bust of my father came out incredibly detailed and lifelike. It's now proudly displayed in our living room. Abhijeet's craftsmanship is truly exceptional. Worth every rupee!",
    image:
      "https://customer-assets.emergentagent.com/job_ice-prints/artifacts/j6xbuu51_IMG_4148.jpeg",
  },
  {
    id: 5,
    name: "Vikram Thakur",
    location: "Zirakpur",
    rating: 5,
    product: "Custom Keyrings",
    review:
      "Ordered personalized keyrings with vehicle numbers and business addresses for multiple clients. The detail is crisp and the prints are very durable. Fast delivery too!",
    image:
      "https://customer-assets.emergentagent.com/job_ice-prints/artifacts/ywgmlh7q_IMG_4368.jpeg",
  },
];

export const orderSteps = [
  {
    step: 1,
    title: "Send Your Design",
    description: "Share your design file or describe your idea on WhatsApp",
    icon: "MessageCircle",
  },
  {
    step: 2,
    title: "Get a Quote",
    description: "Receive a detailed quote with timeline and pricing",
    icon: "FileText",
  },
  {
    step: 3,
    title: "Pay via UPI",
    description: "Make easy and secure payment through UPI or scan our QR code",
    icon: "Smartphone",
  },
  {
    step: 4,
    title: "Collect Your Print",
    description: "Pick up your finished 3D printed product from our location",
    icon: "Package",
  },
];
